import BaseComponent from '../../../general/js/base-component';
import TimelineLite from 'gsap/TimelineLite';
import createEvent from '../../../general/js/create-event';

export default class BuyingSellingComponent extends BaseComponent{
    constructor() {
        super(...arguments);

        this.content = this.refs.content;
        this.select = this.refs.select;
        this.onTypeSelect = this.onTypeSelect.bind(this);

        this.init();
    }

    static getRequiredRefs(){
        return ['select'];
    }

    init() {
        this.select.addEventListener('change', this.onTypeSelect);
        this.onTypeSelect();
    }

    onTypeSelect() {
        let timeline = new TimelineLite();
        timeline.to(this.content, 0.3, {opacity: 0, onComplete: () => {
            if(this.select.value == 'buyer'){
                this.element.classList.add('is-buyer');
                this.element.classList.remove('is-seller');
            }else{
                this.element.classList.remove('is-buyer');
                this.element.classList.add('is-seller');
            }

            document.dispatchEvent(createEvent('buyingSelling:switch'))
        }});
        timeline.to(this.content, 0.5, {opacity: 1});
    }

    onDestroy() {
        this.select.removeEventListener('change', this.onTypeSelect);
    }
}



// WEBPACK FOOTER //
// ./app/components/buying-selling/js/buying-selling.component.js